<template>
  <section class="article-overview">
    <div class="article-overview__container">

    </div>
  </section>
</template>

<script>
export default {
  name: 'article-overview',
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.article-overview{
  &__container{
    @extend %container;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ArticleOverview/ArticleOverview.vue